export default __webpack_public_path__ + "static/media/patti-finish.f3a55e8b.png";